module.exports = (el) => {
  const wrapper = $(el);
  const searchForm = wrapper.find('#searchForm');
  const termEl = searchForm.find('input[name="term"]');
  const hymnalEl = searchForm.find('select[name="hymnal"]');
  const hymnEl = searchForm.find('input[name="hymn"]');
  const shouldRedirect = wrapper.data('redirect');

  let openBrowseBy = null;
  let refineSearch = {};
  let searchType = '';
  let downloadsOnly = false;
  let dataArr = [];

  let currentPage = 1;
  let field = 'all';
  let pendingRequest = false;
  let maxPages;
  let changePage = false;

  $('.field-dropdown').on('changed', function (e, option) {
    field = $(this).data('val');

    termEl.attr('placeholder', $(option).data('placeholder'));
  });

  searchForm.submit(function (e) {
    e.preventDefault();

    if (!pendingRequest) {
      pendingRequest = true;

      searchType = getSearchType();

      if (
        searchType != 'submit-term'
        && searchType != 'submit-hymn'
        && searchType != 'term'
        && searchType != 'hymn'
        && $('#hidden-type').length > 0
      ) {
        searchType = $('#hidden-type').val();
      } else {
        $('#hiddenInputs').html('');

        $('.browse-by:visible').slideToggle(300);
      }

      $('#search-overlay').show();
      $('.btn-search').loading();

      const form = $(this);
      dataArr = $(this).serializeArray();

      if (!searchType.length) {
        searchType = 'submit-term';
      }

      if (shouldRedirect) {
        return redirectToSearchPage();
      }

      if (!changePage) {
        currentPage = 1;
        $('.page-number-input').val(1);
      } else {
        changePage = false;
      }

      $.post(urlLoadSearchResults, {
        dataArr,
        searchType,
        downloadsOnly,
        page: currentPage,
        refineSearch,
        field
      }, (data) => {
        pendingRequest = false;

        if (openBrowseBy != null) {
          const id = `#${openBrowseBy}`;
          $('#browseby li').removeClass('active');
          $(`#browseby li[data-target="${id}"]`).addClass('active');

          toggleElementWithOtherElement(id, 'div.browse-by');

          openBrowseBy = null;
        }

        $('#search-overlay').hide();
       $('.btn-search').loading('reset');

        if (data.isError === 1) {
          toastr.error(data.msgError);
        } else {
          if (data.results > 0) {
            $('#btnReportAllSelectedSongs').show();
          } else {
            $('#btnReportAllSelectedSongs').hide();
          }

          maxPages = data.pages;


          const term = termEl.val();

          $('#submission-title').attr('href', function () {
            const url = this.href.split('?')[0];
            return `${url}?term=${term}`;
          });

          $('#page-count').html(__('of {numOfPages}', { numOfPages: data.pages }));

          $('div.result-info, div.result-info2').show();
          $('div.not-find-info').show();
          if (!data.pages) {
            $('.page-pagination-div').hide();
          } else {
            $('.page-pagination-div').show();
          }
          $('.search-music-wrapper .search-music-results').html(data.html);

          $('.page-number-input').val(data.currentPage);

          if (parseInt(data.pages) > 0) {
            $('div.page-pagination-div').show();
          } else {
            $('div.page-pagination-div').hide();
          }

          populateRefineSearchBadges();

          $('[data-toggle="popover"]').popover({
            placement: 'top',
            html: true,
            content: `<div class="row"><div class="col-xs-12"><p>${__('PDF and TIFF files are available to license holders to make creating worship aids easy!')}</p></div>`
              + `<div class="col-xs-12 col-sm-7 padding-left-0 padding-right-0"> <a href="${purchaseLoginUrl}" class="btn btn-block btn-green btn-thin ">${__('Purchase License')}</a></div>`
              + `<div class="col-xs-12 col-sm-5"><a href="${loginUrl}" class="btn btn-block btn-brown-thin">${__('Login')}</a></div> </div>`
          });
        }

        /* build current search url */
        const url = buildSearchUrl();

        let formTerm = termEl.val();
        const formHymnal = hymnalEl.val();
        const formHymn = hymnEl.val();
        let formHiddenVal = $('input[name="hidden-value"]').val();

        if (formTerm != '' || formHymnal != '' || formHymn != '' || (formHiddenVal != '' && formHiddenVal != null)) {
          history.pushState({}, null, url);
        }
      });
    }
  });

  if (!shouldRedirect) {
    populateFormFromGet();
    searchForm.submit();
  }

  function redirectToSearchPage() {
    window.location = buildSearchUrl();
  }

  function buildSearchUrl() {
    let formTerm = termEl.val();

    const searchParams = {
      term: formTerm,
      field: field,
      page: currentPage,
    };

    $.each(refineSearch, (filterId, filterObject) => {
      $.each(filterObject, (type, value) => {
        const filter = encodeURIComponent(value);

        if (!(type in searchParams)) searchParams[type] = filter;
        else searchParams[type] += `&&${filter}`;
      });
    });

    return `${urlSearch}?${jQuery.param(searchParams)}`;
  }

  function getSearchType() {
    let type = '';

    const term = termEl.val() ?? '';
    const hymnal = hymnalEl.val() ?? '';
    const hymn = hymnEl.val() ?? '';

    if (term.length) {
      type = 'submit-term';
    } else if (hymnal.length || hymn.length) {
      type = 'submit-hymn';
    }

    return type;
  }

  function populateFormFromGet() {
    const params = {};
    const url = window.location.href;

    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      key = decodeURIComponent(key);
      value = decodeURIComponent(value.replace(/\+/g, '%20'));
      params[key] = value;
    });

    if ('term' in params) {
      const term = decodeURIComponent(params.term);
      termEl.val(term);
    }

    if ('field' in params) {
      field = decodeURIComponent(params.field);
      $(() => {
        $('.field-dropdown').trigger('select', field);
      });
    }

    if ('downloads-only' in params) {
      downloadsOnly = decodeURIComponent(params['downloads-only']) === 'true';
      $('input[name="downloads-only"]').prop('checked', downloadsOnly);
    }

    if ('hymnal' in params) hymnalEl.val(params.hymnal);
    if ('hymn' in params) hymnEl.val(params.hymn);
    if ('page' in params) {
      currentPage = params.page;
      changePage = true;
    };

    if ('contributor' in params) refineByArray('contributor', decodeURIComponent(params.contributor).split('&&'));
    if ('psalm' in params) refineByArray('psalm', decodeURIComponent(params.psalm).split('&&'));
    if ('tune' in params) refineByArray('tune', decodeURIComponent(params.tune).split('&&'));
    if ('meter' in params) refineByArray('meter', decodeURIComponent(params.meter).split('&&'));
    if ('publisher' in params) refineByArray('publisher', decodeURIComponent(params.publisher).split('&&'));

    if ('addition' in params && params.addition != '') {
      $('#hiddenInputs').html('');

      const addition = decodeURIComponent(params.addition);

      const inputValue = $('<input>')
        .attr('type', 'hidden')
        .attr('name', 'hidden-value')
        .attr('id', 'hidden-value')
        .val(addition);
      const inputType = $('<input>')
        .attr('type', 'hidden')
        .attr('name', 'hidden-type')
        .attr('id', 'hidden-type')
        .val(params.type);

      $('#hiddenInputs').append(inputValue);
      $('#hiddenInputs').append(inputType);
    }
    if ('open' in params) openBrowseBy = params.open;
  }

  $(document).delegate('body', 'click', (e) => {
    $('[data-toggle="popover"]').each(function () {
      if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
        $(this).on('hidden.bs.popover', function () {
          $(this).parent().find('div.popover').hide();
        });
        $(this).popover('hide');
      }
    });
  });

  hymnalEl.select2({
    placeholder: __('Hymnals / Resources'),
    allowClear: true
  });

  hymnalEl.change(function() {
    if ($(this).val().length) {
      termEl.val('');
    }
  });

  hymnEl.change(function() {
    termEl.val('');
  });

  termEl.change(function() {
    hymnalEl.val('').trigger('change');
    hymnEl.val('');
  });

  $('.next-page').click((e) => {
    if (!pendingRequest && parseInt(currentPage) < parseInt(maxPages)) {
      currentPage++;
      changePage = true;
      searchForm.submit();
    }

    e.preventDefault();
  });

  $('.previous-page').click((e) => {
    if (!pendingRequest && parseInt(currentPage) > 1) {
      currentPage--;
      changePage = true;
      searchForm.submit();
    }

    e.preventDefault();
  });

  $('.page-number-input').donetyping(function () {
    const nextPage = parseInt($(this).val());

    if (!isNaN(nextPage)) {
      if (nextPage >= 1 && nextPage <= maxPages) {
        currentPage = nextPage;
        changePage = true;
        searchForm.submit();
      }
    } else {
      $(this).val(currentPage);
    }
  });

  $('.previous-page').click((e) => {
    if (!pendingRequest && parseInt(currentPage) > 1) {
      currentPage--;
      searchForm.submit();
    }

    e.preventDefault();
  });

  /* BEGIN BROWSE BY */
  $('#browseby li').click(function () {
    const id = $(this).data('target');
    $('#browseby li').removeClass('active');

    $(this).addClass('active');

    toggleElementWithOtherElement(id, 'div.browse-by');
  });

  $('#toggle-publisher-list').click(() => {
    $('#browse-by-publisher-list').slideToggle(300);
  });
  $('#browse-by-publisher-list a').click(function (e) {
    const value = `${$(this).data('publisher')}\\${$(this).data('publisher')}`;

    refineSearchBy('publisher', value);
    searchForm.submit();

    /* hide list when search performed */
    $('#browse-by-publisher-list:visible').slideToggle(300);

    e.preventDefault();
  });

  $('#toggle-composer-list').click(() => {
    $('#browse-by-composer-list').slideToggle(300);
  });
  $('#browse-by-composer-list a').click(function (e) {
    const value = `${$(this).data('composer')}\\${$(this).data('composer')}`;

    refineSearchBy('composer', value);
    searchForm.submit();

    /* hide list when search performed */
    $('#browse-by-composer-list:visible').slideToggle(300);

    e.preventDefault();
  });

  $('#toggle-artist-list').click(() => {
    $('#browse-by-artist-list').slideToggle(300);
  });
  $('#browse-by-artist-list a').click(function (e) {
    const value = `${$(this).data('artist')}\\${$(this).data('artist')}`;

    refineSearchBy('artist', value);
    searchForm.submit();

    /* hide list when search performed */
    $('#browse-by-artist-list:visible').slideToggle(300);

    e.preventDefault();
  });

  $('#toggle-album-list').click(() => {
    $('#browse-by-album-list').slideToggle(300);
  });
  $('#browse-by-album-list a').click(function (e) {
    const value = `${$(this).data('album')}\\${$(this).data('album')}`;

    refineSearchBy('album', value);
    searchForm.submit();

    /* hide list when search performed */
    $('#browse-by-album-list:visible').slideToggle(300);

    e.preventDefault();
  });

  $('#toggle-label-list').click(() => {
    $('#browse-by-label-list').slideToggle(300);
  });
  $('#browse-by-label-list a').click(function (e) {
    const value = `${$(this).data('label')}\\${$(this).data('label')}`;

    refineSearchBy('label', value);
    searchForm.submit();

    /* hide list when search performed */
    $('#browse-by-label-list:visible').slideToggle(300);

    e.preventDefault();
  });
  /* END BROWSE BY */

  function toggleElementWithOtherElement(idToShow, idToHide) {
    if ($(idToShow).is(':visible')) {
      $(idToShow).slideToggle(300);
    } else if ($(`${idToHide}:visible`).length > 0) {
      $(`${idToHide}:visible`).slideToggle(300, () => {
        $(idToShow).slideToggle(300);
      });
    } else {
      $(idToShow).slideToggle(300);
    }
  }

  function performSearchBy(type, value) {
    if (!pendingRequest) {
      currentPage = 1;

      $('#hiddenInputs').html('');

      const inputValue = $('<input>')
        .attr('type', 'hidden')
        .attr('name', 'hidden-value')
        .attr('id', 'hidden-value')
        .val(value);
      const inputType = $('<input>')
        .attr('type', 'hidden')
        .attr('name', 'hidden-type')
        .attr('id', 'hidden-type')
        .val(type);

      $('#hiddenInputs').append(inputValue);
      $('#hiddenInputs').append(inputType);

      searchForm.submit();
    }
  }

  function populateRefineSearchBadges() {
    let html = '';
    let mainFilter = '';
    const data = {};

    $.each(dataArr, (key, value) => {
      data[value.name] = value.value;
    });

    switch (searchType) {
      case 'submit-term':
        mainFilter = decodeURIComponent(data.term.replace(/\+/g, '%20'));
        break;
      case 'submit-hymn':
        mainFilter = (data.hymnal ? data.hymnal : '') + (data.hymnal && data.hymn ? ' - ' : '') + (data.hymn ? `Hymn: ${data.hymn}` : '');
        break;
      default:
        mainFilter = data['hidden-value'];
        break;
    }

    const filters = mainFilter ? jQuery.extend(true, { main: mainFilter }, refineSearch) : refineSearch;

    $.each(filters, (key, value) => {
      let innerKey;
      let innerValue;

      if (value !== null && typeof value === 'object') {
        innerKey = Object.keys(value)[0];
        innerValue = value[innerKey];
      } else {
        innerKey = key;
        innerValue = value;
      }

      let text = innerKey == 'psalm' ? 'Psalm: ' : '';

      text += innerValue.split('\\')[0];
      if (key == 'main') {
        html += `<div class="badge">${
            text
          }<i class="badge-delete-button" id="main">X</i>`
          + '</div>';
      } else {
        html += `<div class="badge">${
            text
          }<i class="badge-delete-button" id="${md5(innerKey + innerValue)}">X</i>`
          + '</div>';
      }
    });

    if (html.length) {
      $('#search-term').html(` matching results for <em>${html}</em>`);
      $('.search-visible').fadeIn(200);
      $('.result-info').addClass('term-entered');
    } else {
      $('#search-term').html(` Please enter your search term in the provided search form above`);
      $('.search-visible').fadeOut(200);
      $('.result-info').removeClass('term-entered');
    }



    $('.badge-delete-button').click(function () {
      deleteRefineSearchBadges($(this).attr('id'));

      $(this).parent().fadeOut(150, function () {
        $(this).remove();
      });
    });
  }

  function refineSearchBy(type, value) {
    const data = {};
    data[type] = value;

    refineSearch[md5(type + value)] = data;
  }

  function deleteRefineSearchBadges(elem) {
    if (elem == 'main') {
      delete refineSearch[elem];
      termEl.val('');
      hymnalEl.val('').trigger('change');
      hymnEl.val('');
      $('input[name="hidden-value"]').val('');
      $('#hidden-type').val('');
    } else {
      delete refineSearch[elem];
    }

    searchForm.submit();
  }

  function refineByArray(type, array) {
    $.each(array, (key, value) => {
      refineSearchBy(type, value);
    });
  }

  searchForm.on("reactRefineBy", function( e, type, value ) {
    refineSearchBy(type, value);

    searchForm.submit();
  });
};
